import { SegmentStrategy } from "../rules/intoSegments";
import { RuleSet } from "../rules/ruleSet";

/*
n z ɫ ŋ k d t s m ɹ ɡ p v f b ʃ θ tʃ dʒ ð ʒ
i u ɛ ɔ ɪ ʊ ɑ æ ə ʌ ɚ ɝ eɪ̯ aɪ̯ aʊ̯ ɔɪ̯ oʊ̯
*/

/** rough approximation of English spelling */
export const ipaToEnglish: RuleSet = {
  inputSegments: SegmentStrategy.Ipa,
  outputSegments: SegmentStrategy.Single,
  rules: [
    // remove stress
    { from: 'ˈ', to: '' },
    { from: 'ˌ', to: '' },

    // silent e after some consonants
    // eɪ̯C -> aCe
    { from: 'eɪ̯n', to: 'ane', next: ['#word'] },
    { from: 'eɪ̯z', to: 'aze', next: ['#word'] },
    { from: 'eɪ̯ɫ', to: 'ale', next: ['#word'] },
    { from: 'eɪ̯k', to: 'ake', next: ['#word'] },
    { from: 'eɪ̯d', to: 'ade', next: ['#word'] },
    { from: 'eɪ̯t', to: 'ate', next: ['#word'] },
    { from: 'eɪ̯s', to: 'ase', next: ['#word'] },
    { from: 'eɪ̯m', to: 'ame', next: ['#word'] },
    { from: 'eɪ̯ɹ', to: 'are', next: ['#word'] },
    { from: 'eɪ̯ɡ', to: 'ague', next: ['#word'] },
    { from: 'eɪ̯g', to: 'ague', next: ['#word'] },
    { from: 'eɪ̯p', to: 'ape', next: ['#word'] },
    { from: 'eɪ̯v', to: 'ave', next: ['#word'] },
    { from: 'eɪ̯f', to: 'afe', next: ['#word'] },
    { from: 'eɪ̯b', to: 'abe', next: ['#word'] },
    { from: 'eɪ̯ð', to: 'athe', next: ['#word'] },
    { from: 'eɪ̯tʃ', to: 'ache', next: ['#word'] },
    { from: 'eɪ̯dʒ', to: 'aje', next: ['#word'] },
    // iC -> eCe or eeC
    { from: 'in', to: 'ene', next: ['#word'] },
    { from: 'iz', to: 'eze', next: ['#word'] },
    { from: 'iɫ', to: 'eel', next: ['#word'] },
    { from: 'ik', to: 'eek', next: ['#word'] },
    { from: 'id', to: 'eed', next: ['#word'] },
    { from: 'it', to: 'eet', next: ['#word'] },
    { from: 'is', to: 'ese', next: ['#word'] },
    { from: 'im', to: 'eem', next: ['#word'] },
    { from: 'iɹ', to: 'eer', next: ['#word'] },
    { from: 'iɡ', to: 'eeg', next: ['#word'] },
    { from: 'ig', to: 'eeg', next: ['#word'] },
    { from: 'ip', to: 'eep', next: ['#word'] },
    { from: 'iv', to: 'eve', next: ['#word'] },
    { from: 'if', to: 'eef', next: ['#word'] },
    { from: 'ib', to: 'eeb', next: ['#word'] },
    { from: 'ið', to: 'ethe', next: ['#word'] },
    { from: 'itʃ', to: 'eech', next: ['#word'] },
    { from: 'idʒ', to: 'eje', next: ['#word'] },
    // aɪ̯C -> iCe
    { from: 'aɪ̯n', to: 'ine', next: ['#word'] },
    { from: 'aɪ̯z', to: 'ize', next: ['#word'] },
    { from: 'aɪ̯ɫ', to: 'ile', next: ['#word'] },
    { from: 'aɪ̯k', to: 'ike', next: ['#word'] },
    { from: 'aɪ̯d', to: 'ide', next: ['#word'] },
    { from: 'aɪ̯t', to: 'ite', next: ['#word'] },
    { from: 'aɪ̯s', to: 'ise', next: ['#word'] },
    { from: 'aɪ̯m', to: 'ime', next: ['#word'] },
    { from: 'aɪ̯ɹ', to: 'ire', next: ['#word'] },
    { from: 'aɪ̯ɡ', to: 'igue', next: ['#word'] },
    { from: 'aɪ̯g', to: 'igue', next: ['#word'] },
    { from: 'aɪ̯p', to: 'ipe', next: ['#word'] },
    { from: 'aɪ̯v', to: 'ive', next: ['#word'] },
    { from: 'aɪ̯f', to: 'ife', next: ['#word'] },
    { from: 'aɪ̯b', to: 'ibe', next: ['#word'] },
    { from: 'aɪ̯ð', to: 'ithe', next: ['#word'] },
    { from: 'aɪ̯tʃ', to: 'iche', next: ['#word'] },
    { from: 'aɪ̯dʒ', to: 'ije', next: ['#word'] },
    // oʊ̯C -> oCe
    { from: 'oʊ̯n', to: 'one', next: ['#word'] },
    { from: 'oʊ̯z', to: 'oze', next: ['#word'] },
    { from: 'oʊ̯ɫ', to: 'ole', next: ['#word'] },
    { from: 'oʊ̯k', to: 'oke', next: ['#word'] },
    { from: 'oʊ̯d', to: 'ode', next: ['#word'] },
    { from: 'oʊ̯t', to: 'ote', next: ['#word'] },
    { from: 'oʊ̯s', to: 'ose', next: ['#word'] },
    { from: 'oʊ̯m', to: 'ome', next: ['#word'] },
    { from: 'oʊ̯ɹ', to: 'ore', next: ['#word'] },
    { from: 'oʊ̯ɡ', to: 'ogue', next: ['#word'] },
    { from: 'oʊ̯g', to: 'ogue', next: ['#word'] },
    { from: 'oʊ̯p', to: 'ope', next: ['#word'] },
    { from: 'oʊ̯v', to: 'ove', next: ['#word'] },
    { from: 'oʊ̯f', to: 'ofe', next: ['#word'] },
    { from: 'oʊ̯b', to: 'obe', next: ['#word'] },
    { from: 'oʊ̯ð', to: 'othe', next: ['#word'] },
    { from: 'oʊ̯tʃ', to: 'oche', next: ['#word'] },
    { from: 'oʊ̯dʒ', to: 'oje', next: ['#word'] },
    // uC -> uCe
    { from: 'un', to: 'une', next: ['#word'] },
    { from: 'uz', to: 'uze', next: ['#word'] },
    { from: 'uɫ', to: 'ule', next: ['#word'] },
    { from: 'uk', to: 'uke', next: ['#word'] },
    { from: 'ud', to: 'ude', next: ['#word'] },
    { from: 'ut', to: 'ute', next: ['#word'] },
    { from: 'us', to: 'use', next: ['#word'] },
    { from: 'um', to: 'ume', next: ['#word'] },
    { from: 'uɹ', to: 'ure', next: ['#word'] },
    { from: 'uɡ', to: 'ugue', next: ['#word'] },
    { from: 'ug', to: 'ugue', next: ['#word'] },
    { from: 'up', to: 'upe', next: ['#word'] },
    { from: 'uv', to: 'uve', next: ['#word'] },
    { from: 'uf', to: 'ufe', next: ['#word'] },
    { from: 'ub', to: 'ube', next: ['#word'] },
    { from: 'uð', to: 'uthe', next: ['#word'] },
    { from: 'utʃ', to: 'uche', next: ['#word'] },
    { from: 'udʒ', to: 'uje', next: ['#word'] },

    // special combos
    { from: 'ks', to: 'x' },
    { from: 'kw', to: 'qu' },
    { from: 'hw', to: 'wh', previous: ['#word'] },
    { from: 'ˈhw', to: 'wh', previous: ['#word'] },
    { from: 'li', to: 'ly', next: ['#word'] },
    { from: 'ɫi', to: 'ly', next: ['#word'] },

    // English diphthong phonemes
    { from: 'eɪ̯', to: 'ay', next: ['#word'] }, { from: 'ei', to: 'ay', next: ['#word'] },
    { from: 'eɪ̯', to: 'ā' }, { from: 'ei', to: 'ā' },
    { from: 'aɪ̯', to: 'ī' },
    { from: 'aʊ̯', to: 'ow' },
    { from: 'ɔɪ̯', to: 'oy', next: ['#word'] }, { from: 'ɔɪ̯', to: 'oi' },
    { from: 'oʊ̯', to: 'ō' },
    { from: 'ʊɹ', to: 'or' },

    // English vowel phonemes
    { from: 'i', to: 'ee', next: ['#word'] }, { from: 'i', to: 'ē' },
    { from: 'u', to: 'ū' },
    { from: 'ɛ', to: 'e' },
    { from: 'ɔ', to: 'o' },
    { from: 'ɪ', to: 'i' },
    { from: 'ʊ', to: 'oo' },
    { from: 'ɑ', to: 'ah' },
    { from: 'æ', to: 'æ' },
    { from: 'ə', to: 'u' }, { from: 'ʌ', to: 'u' },
    { from: 'ɚ', to: 'er' }, { from: 'ɝ', to: 'er' },

    // English consonant phonemes
    { from: 'j', to: 'y' },
    { from: 'ɫ', to: 'l' },
    { from: 'ɡ', to: 'g' },
    { from: 'ŋ', to: 'ng' },
    { from: 't̠ʃ', to: 'ch' }, { from: 'tʃ', to: 'ch' },
    { from: 'ʃ', to: 'sh' },
    { from: 'd̠ʒ', to: 'j' }, { from: 'dʒ', to: 'j' },
    { from: 'ʒ', to: 'zh' },
    { from: 'ð', to: 'th' },
    { from: 'θ', to: 'th' },
    { from: 'ɹ', to: 'r' },

    // other consonants
    { from: 't̪', to: 't' },
    { from: 'd̪', to: 'd' },
    { from: 'n̪', to: 'n' },
    { from: 'r̪', to: 'rr' },
    { from: 'ɾ̪', to: 'ɾ' },
    { from: 'ɽ', to: 'ɾ' },
    { from: 'ʔ', to: "'" },
    { from: 'l̪', to: 'l' },
    { from: 'ɭ', to: 'l' },
    { from: 'l̩', to: 'l' },
    { from: 'm̩', to: 'm' },
    { from: 'n̩', to: 'n' },
    { from: 'ɲ', to: 'ñ' },
    { from: 'ʎ', to: 'll' },
    { from: 'r', to: 'rr' },
    { from: 'ɟ', to: 'j' },
  ]
}
